import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'complete-system',
    templateUrl: './complete-system.component.html',
    styleUrls: ['./complete-system.component.scss']
})
export class CompleteSystemComponent implements OnInit {

    @Input() heading: string = 'Complete System';
    @Input() slogan: string = 'Large Households, Farms, Small to Medium Businesses';
    @Input() headerCssClass: string = 'p-3';

    @Input() showImage: boolean = true;
    @Input() showHeading: boolean = false;
    @Input() showEmpty: boolean = true;

    constructor() {
    }

    ngOnInit(): void {
    }
}
